import { StyleSheet } from 'react-native'

import STYLES from '../../constants/styles'

export default StyleSheet.create({
    appContainer: {
        backgroundColor: STYLES.BACKGROUND_COLOR
        , width: STYLES.WIDTH
        , height: STYLES.HEIGHT
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    loading: {
        ...StyleSheet.absoluteFillObject
        , position: 'absolute'
        , backgroundColor: STYLES.BACKDROP_COLOR
    }
})



// WEBPACK FOOTER //
// ./src/containers/main/styles.js